<template>
    <v-form
        class="kus-home-public-subscribe--container mt-4"
        v-model="valid"
        ref="form"
        lazy-validation
        @submit.stop.prevent="submit">
        <v-card :loading="loading ? 'secondary' : false" v-if="active">
            <kus-card-title :title="$t('home.publicSubscribe.title')" :dismissible="false" />
            <v-card-text>
                <p>{{ $t('home.publicSubscribe.help') }}</p>
                <kus-user-form-name
                    v-model="user.firstname"
                    :label="$t('users.form.firstname')"
                    name="firstname" />

                <kus-user-form-name
                    v-model="user.lastname"
                    :label="$t('users.form.lastname')"
                    name="lastname" />

                <kus-user-form-password
                    v-model="password.password"
                    :label="$t('users.account.password')"
                    required />

                <kus-user-form-password
                    v-model="password.confirm"
                    :rules-eq="password.password"
                    :rules-eq-msg="$t('home.publicSubscribe.passwordSame')"
                    :label="$t('users.account.passwordConfirm')"
                    required />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    type="submit"
                    :disabled="!valid"
                    :loading="loading"
                    class="primary kus-btn-center">
                    {{ $t('home.publicSubscribe.send') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-alert v-if="!active && !loading" text color="error">
            {{ $t('home.publicSubscribe.notFound') }}
        </v-alert>
    </v-form>
</template>

<script>
import KusUserFormName from '@/modules/user/form/KusUserFormName'
import KusUserFormPassword from '@/modules/user/form/KusUserFormPassword'
import KusCardTitle from '@/modules/card/KusCardTitle'

export default {
    name: 'kus-home-public-subscribe',
    props: {
        token: { type: String, required: true }
    },
    components: { KusCardTitle, KusUserFormPassword, KusUserFormName },
    data: () => ({
        valid: false,
        loading: false,
        password: {},
        user: {
            password: '',
            firstname: '',
            lastname: ''
        },
        active: false
    }),

    mounted() {
        this.load()
    },

    methods: {
        load() {
            this.loading = true
            return this.$api.get(`/accounts/subscribe/${this.token}`)
                .then(() => (this.active = true))
                .finally(() => (this.loading = false))
        },

        submit() {
            if (!this.$refs.form.validate()) {
                return
            }
            this.loading = true
            this.user.password = this.password.password
            return this.$store.dispatch('auth/subscribe', { token: this.token, user: this.user })
                .then(() => {
                    this.$store.commit('msg/show', { message: this.$i18n.t('home.publicSubscribe.success') })
                    this.$router.push({ name: 'client' })
                })
                .finally(() => (this.loading = false))
        }
    }
}
</script>

<style lang="sass">
.kus-home-public-subscribe--container
    max-width: 600px
    margin: 0 auto

</style>
